export default __webpack_public_path__ + "static/media/bulb-on-min.4a8f28d3.png";